import { BrowserRouter } from "react-router-dom";
import AppTree from "./AppTree";

/**
 * ブラウザ側の外枠。中身は `AppTree` が持つ（プリレンダーと共有している）。
 * ここに描画に関わるものを足さないこと——足すとプリレンダー結果と食い違い、
 * 表示の瞬間にちらつく。足すなら `AppTree` 側へ。
 */
function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppTree />
    </BrowserRouter>
  );
}

export default App;
